import { ProReportCorrespondentAdvice } from '../../../models/pro.model';
import { tableSubHeaderColour, tableWidth } from '../pro-report-email-styles';
import {
  ProReportEmailFullWidthInfoRow,
  ProReportEmailFullWidthTableHeader,
} from './pro-report-email-common-components';
import ProReportEmailNoDataPlaceHolder from './pro-report-email-no-data';

function ProReportEmailCorrespondentAdvice({
  correspondentDescription,
  correspondentAdvice,
}: {
  correspondentDescription: string | null;
  correspondentAdvice:
    | string
    | ProReportCorrespondentAdvice[]
    | null
    | undefined;
}) {
  const headerText = 'Correspondent advice';
  if (correspondentAdvice) {
    return (
      <table
        width={tableWidth}
        cellPadding={0}
        cellSpacing={0}
        style={{ borderCollapse: 'collapse', margin: 0, padding: 0 }}
        role="presentation"
      >
        <ProReportEmailFullWidthTableHeader headerText={headerText} />

        {typeof correspondentAdvice === 'string' && (
          <tbody>
            {correspondentDescription && (
              <ProReportEmailFullWidthInfoRow
                heading="Correspondent:"
                content={correspondentDescription || 'N/A'}
                backgroundColor={tableSubHeaderColour}
              />
            )}
            <ProReportEmailFullWidthInfoRow
              heading="Advice:"
              content={correspondentAdvice}
            />
          </tbody>
        )}
        {Array.isArray(correspondentAdvice) && (
          <tbody>
            {correspondentAdvice.map((advice) => (
              <>
                <ProReportEmailFullWidthInfoRow
                  heading="Correspondent:"
                  content={advice.correspondent}
                  backgroundColor={tableSubHeaderColour}
                  key={advice.correspondent}
                />
                <ProReportEmailFullWidthInfoRow
                  heading="Advice:"
                  content={advice.advice}
                  key={advice.correspondent}
                />
              </>
            ))}
          </tbody>
        )}
      </table>
    );
  }
  return (
    <ProReportEmailNoDataPlaceHolder
      header={headerText}
      subHeading="Advice:"
      content="No feedback provided."
    />
  );
}

export default ProReportEmailCorrespondentAdvice;
